export { default as UspValueBlock } from "src/organisms/UspValueBlock/UspValueBlock";
